import React, { useEffect, useState, useRef } from "react";

export default function AutoCompleteMultiSelectInput({
  name,
  setSearchKeyword,
  setFieldValue,
  onBlur,
  options,
  label,
  disabled,
  marginBottom,
  error,
  touched,
  noMatchError = "",
  optionComponent: OptionComponent,
  selectedComponent: SelectedComponent,
  autocomplete = "off",
}) {
  const [searchKeywordValue, setSearchKeywordValue] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsSet, setSelectedOptionsSet] = useState(new Set());
  const [showDDL, setShowDDL] = useState(true);

  const dropDownRef = useRef();
  const inputFieldRef = useRef();

  useEffect(() => {
    document.addEventListener("click", clickHandler);
    return () => {
      document.removeEventListener("click", clickHandler);
    };
  }, []);

  useEffect(() => {
    setShowDDL(true);
  }, [options]);

  useEffect(() => {
    setFieldValue(name, selectedOptions);
  }, [selectedOptions, name, setFieldValue]);

  function clickHandler(e) {
    if (e.target === inputFieldRef.current) {
      return;
    }
    if (!dropDownRef?.current?.contains(e.target)) {
      setShowDDL(false);
    }
  }

  function changeSearchKeyword(e) {
    setSearchKeyword(e.target.value);
    setSearchKeywordValue(e.target.value);
  }

  function addOption(newOption) {
    if (selectedOptionsSet.has(newOption.id)) {
      return;
    }
    const tempSet = selectedOptionsSet;
    tempSet.add(newOption.id);
    setSelectedOptions([...selectedOptions, newOption]);
    setSelectedOptionsSet(tempSet);
    setSearchKeywordValue("");
  }

  function removeSelected(optionToBeRemoved) {
    const tempSelectedOptions = selectedOptions.filter((option) => option.id !== optionToBeRemoved.id);
    const tempSet = selectedOptionsSet;
    tempSet.delete(optionToBeRemoved.id);
    setSelectedOptionsSet(tempSet);
    setSelectedOptions(tempSelectedOptions);
  }

  function isNoMatchFound() {
    return searchKeywordValue && options.length === 0 && noMatchError.length;
  }

  return (
    <div className="input-text">
      <div className="did-floating-label-content" style={{ marginBottom: marginBottom ? marginBottom + "px" : "27px" }}>
        <input
          ref={inputFieldRef}
          name={name}
          className="did-floating-input"
          placeholder=" "
          onBlur={onBlur}
          value={searchKeywordValue}
          onChange={changeSearchKeyword}
          disabled={disabled}
          onClick={() => setShowDDL(!showDDL)}
          autoComplete={autocomplete === "off" ? "new-password" : autocomplete}
          data-form-type="other"
          data-lpignore="true"
          data-1p-ignore="true"
        />

        {showDDL && options.length > 0 && (
          <div
            ref={dropDownRef}
            className="autocomplete-dropdown"
            style={{
              position: "absolute",
              zIndex: 5,
              top: "calc(100% - 1px)",
              insetInlineStart: 0,
              width: "100%",
              background: "white",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.12)",
              padding: "4px",
              maxHeight: "240px",
              overflowY: "auto",
            }}
          >
            {options.map((option) => (
              <div
                key={`option-${option.id}`}
                className="autocomplete-option"
                style={{ borderRadius: "6px" }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  addOption(option);
                  setShowDDL(false);
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <OptionComponent option={option} />
              </div>
            ))}
          </div>
        )}

        <label className="did-floating-label">{label}</label>
        {error && touched ? <div className="input-error">{isNoMatchFound() ? noMatchError : error}</div> : null}

        {selectedOptions.length > 0 && (
          <div className="d-flex flex-wrap" style={{ marginTop: "10px", gap: "10px" }}>
            {selectedOptions.map((option) => (
              <div key={`selected-${option.id}`}>
                <SelectedComponent option={option} onRemove={() => removeSelected(option)} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
